/**
 * Dialog (modal) window for creating a product.
 * Forces creation of a development workspace on product creation.
 * FUTURE: May include option for adding device to newly created development workspace + new product.
 */
let template = `<div class="modal-dialog" id="create-product-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title">
          Create Product
      </div>
      <button type="button" class="btn-close" data-dismiss="modal">X</button>
      <div class="product modal-alert-container">
        <div class="alert" hidden="true"></div>
      </div>
    </div>
    <form>
      <div class="modal-body">
        <div class="form-group devicegroup-name-section">
          <label for="new-product-name">Name</label>
          <input
            type="text"
            maxlength="100"
            name="new-product-name"
            placeholder="Enter a name..."
            class="form-control new-product-name" />
          <span class="help-block name-counter">0 / 100</span>
          <label for="new-product-description">Description</label>
          <textarea class="form-control new-product-description" name="new-product-description" maxlength="300" placeholder="Enter description here"></textarea>
          <span class="help-block new-product-description-counter">0 / 300</span>
        </div>
        <div class="success-content">
            <div class="new-product"></div>
            <ul class="action-grid">
                {{#if show_create_dev_dg}}
                  <li>
                    <i class="fa ei-icon-development_devicegroup" />
                    <span>Develop your POC in a Development Device Group</span>
                    <span class="btn-link dev-dg">Create a Development Device Group</span>
                  </li>
                {{/if}}
                {{#if show_create_test_dg}}
                  <li>
                    <i class="fa ei-icon-pre_production_devicegroup" />
                    <span>Create Test Production Device Groups to practice and evaluate your Factory process.</span>
                    <span class="btn-link preprod-dg">Create a Test Production Device Group</span>
                  </li>
                {{/if}}
                {{#if show_create_prod_dg}}
                  <li>
                    <i class="fa ei-icon-production_devicegroup" />
                    <span>Create Production Device Groups to deploy onto fully blessed devices from a Factory.</span>
                    <span class="btn-link prod-dg">Create a Production Device Group</span>
                  </li>
                {{/if}}
            </ul>
        </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-link success-done" data-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary submit" disabled="true">Create</button>
        <div class="loader">Loading...</div>
      </div>
    </form>
  </div>
</div>`;

let new_product_template = `
<i class="fa fa-cube" />
<main class="product">
<div class="name-field">
  <div class="name-field">
  <div class="name"><strong>{{name}}</strong></div>
  <div class="id-region"></div>
</div>
<div class="info-field">
  <div class="description info"><strong>Description:</strong> {{#if description}}{{description}}{{else}}<em>no description</em>{{/if}}</div>
</div>
`;

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import IDView from '@/views/id_view';

var globalCh = Radio.channel('global');

var MAX_NAME_LENGTH = 100;
var MAX_DESCRIPTION_LENGTH = 300;

var isValidProductName = function (productName) {
    if (!productName) {
        return false;
    }
    if (productName.length <= 0) {
        return false;
    }
    return true;
};
var view = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    ui: {
        submit_btn: 'button.submit',
        load_spinner: '.loader',
        dialog_body: '.modal-body',
        dialog_title: '.modal-title',
        form: '.form-group',
        product_name: '.new-product-name',
        success_content: '.success-content',
        dev_dg: '.dev-dg',
        preprod_dg: '.preprod-dg',
        prod_dg: '.prod-dg',
        ok_close_btn: '.success-done',
        name_length_counter: '.name-counter',
        product_description: '.new-product-description',
        product_description_length_counter: '.new-product-description-counter',
        name: '.name',
        new_product: '.new-product'
    },
    events: {
        'click @ui.dev_dg': 'create_development_devicegroup',
        'click @ui.preprod_dg': 'create_preproduction_devicegroup',
        'click @ui.prod_dg': 'create_production_devicegroup',
        'submit form': 'handle_submit',
        'change @ui.product_name': 'validateProductName',
        'keyup @ui.product_name': 'validateProductName',
        'paste @ui.product_name': 'validateProductName',
        'mouseup @ui.product_name': 'validateProductName',
        'change @ui.product_description': 'validateProductDescription',
        'keyup @ui.product_description': 'validateProductDescription',
        'paste @ui.product_description': 'validateProductDescription',
        'mouseup @ui.product_description': 'validateProductDescription',
    },
    regions: {
        new_product : '@ui.new_product'
    },
    templateContext: function() {
        let active = globalCh.request('active_account');
        let primary = globalCh.request('primary_account');
        return {
            product: this.product,
            show_create_dev_dg: active.permits(primary, 'create_development_devicegroup'),
            show_create_test_dg: active.permits(primary, 'create_pre_production_devicegroup'),
            show_create_prod_dg: active.permits(primary, 'create_production_devicegroup')
        };
    },
    onRender: function() {
        this.ui.success_content.hide();
    },
    validateProductName: function (e) {
        if ( this.ui.product_name.val().length < 1 ) {
            this.ui.submit_btn.prop('disabled', true);
        } else {
            this.ui.submit_btn.prop('disabled', false);
        }
        this.check_validation(
            $(e.target),
            MAX_NAME_LENGTH,
            this.ui.name_length_counter);
    },
    validateProductDescription: function (e) {
        if ( this.ui.product_name.val().length < 1 ) {
            this.ui.submit_btn.prop('disabled', true);
        } else {
            this.ui.submit_btn.prop('disabled', false);
        }
        this.check_validation(
            $(e.target),
            MAX_DESCRIPTION_LENGTH,
            this.ui.product_description_length_counter);
    },
    handle_submit: function(e){
        var ui = this.ui;
        var self = this;
        e.preventDefault();
        this.new_product_submit().then(
            function(new_product){
                self.hideAlert();
                ui.load_spinner.hide();
                ui.form.hide();
                ui.success_content.show();
                ui.submit_btn.hide();
                ui.ok_close_btn.text('Close');
                ui.dialog_title.text('Created Product: ' + new_product.get('name'));
                self.show_new_product(new_product);
            }, 
            function(resp){
                ui.load_spinner.hide();
                self.handle_error(resp);
        });
    },
    new_product_submit: function () {
        var globalCh = Radio.channel('global');
        var apiCh = Radio.channel('api');
        var active_account = globalCh.request('active_account');
        var Products = apiCh.request('product');
        var self = this;
        var ui = this.ui;

        var name = this.ui.product_name.val().trim();
        var description = this.ui.product_description.val().trim();

        if (!isValidProductName(name)) {
            ui.load_spinner.hide();
            self.handle_error(null, 'Invalid Product Name');
            return false;
        }

        this.ui.load_spinner.show();
        return new Promise(function(resolve, reject){
            Products.create({ name: name, description: description },
                {
                    owner: active_account,
                    wait: true,
                    success: resolve,
                    error: function(product, xhr, response){
                        reject(xhr);
                    },
                }
            );
        });
    },
    show_new_product: function(product) {
        this.product = product;
        let product_view = Marionette.View.extend({
            template: Handlebars.compile(new_product_template),
            model: product,
            regions: {
                id_region: '.id-region'
            },
            className: 'section full',
            onRender: function(){
                this.showChildView('id_region', new IDView({ model: this.model }));
            }
        });
        this.showChildView('new_product', new product_view);
    },
    create_development_devicegroup: function(){
        if ( this.product && this.product.type === 'product' ) {
            globalCh.request('show_create_development_devicegroup', this.product);
        }
    },
    create_preproduction_devicegroup: function(){
        if ( this.product && this.product.type === 'product' ) {
            globalCh.request('show_create_pre_production_devicegroup', this.product);
        }
    },
    create_production_devicegroup: function(){
        if ( this.product && this.product.type === 'product' ) {
            globalCh.request('show_create_production_devicegroup', this.product);
        }
    }
});
export default view;


